import { FC, ReactNode } from "react";
import translation from "./locale";
import { CustomProvider } from "rsuite";

interface Props {
  locale: string;
  children: ReactNode;
}

export const DateRangeProvider: FC<Props> = ({ locale, children }) => {
  return (
    <CustomProvider locale={translation[locale as "uz" | "ru" | "oz"]}>
      {children}
    </CustomProvider>
  );
};
